import { autoinject, BindingEngine } from "aurelia-framework";
import { Router } from "aurelia-router";
import { RightShipQiRouterConstants } from "../../../../../configuration/rightshipqi-router.constants";
import { VesselDetailModel } from "../../../../../models/vessels/vessel.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { CustomGridPageBase } from "../../../common/custom-grid-page.base";
import { I18N } from "aurelia-i18n";
import { SourceType } from "../../../../../models/queries/queries.models";
import { VesselPscColumns } from "../../../../../models/pscs/vesselpsc.model";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { RightStoreService } from "../../../../../services/rightstore/rightstore.service";

@autoinject
export class ListVesselPscsForCloseOutDialog extends CustomGridPageBase  {

    vessel: VesselDetailModel;

    constructor(i18N: I18N, protected bindingEngine: BindingEngine,private dialogClientService: DialogClientService, private router: Router,
        private userClaimsService: UserClaimsService, private rightStoreService: RightStoreService) {
        super(i18N,'VesselPscInspections',bindingEngine);
    }

    activate(model: VesselDetailModel) {
        this.vessel = model;
        this.loadPscs();
    }

    close() {
        this.dialogClientService.hide();
    }

    createNewPscInspection() {
        this.dialogClientService.hide();
        this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.AddPsc,
            {
                id: 0,
                vesselId: this.vessel.vesselId,
                internationalMaritimeOrganizationNumber: this.vessel.internationalMaritimeOrganizationNumber ? this.vessel.internationalMaritimeOrganizationNumber : '0',
                vesselName: this.vessel.name
            });
    }

   async loadPscs(){
        this.columns = VesselPscColumns.getColumns(this.userClaimsService, this.dialogClientService, this.rightStoreService, this.vessel);
        this.initialSorting=VesselPscColumns.getColumns(this.userClaimsService, this.dialogClientService, this.rightStoreService, this.vessel);
        this.itemSource = {
            sourceType: SourceType.ODataUrl,
            source: `odata/VesselPscInspections?vesselId=${this.vessel.vesselId}`,
            columns: this.columns,
            initialSorting: this.initialSorting
        };
    }

    refresh()
    {
        if(this.dataGridVM)
            this.dataGridVM.reloadData();
    }
}